//
// ShopBase
//
import PageBase from '@/mixins/PageBase'
import { mapActions } from 'vuex'

export default function ShopBase (title) {
  return {
    mixins: [
      PageBase(title)
    ],
    props: {
      shopid: {
        type: [Number, String],
        required: true
      }
    },
    created () {
      this.addFetcher(enter => {
        return enter ? this.setShopID(this.shopID) : false
      })
      this.addFetcher(enter => {
        return enter ? this.setCategory('special') : false
      })
    },
    computed: {
      shopID () {
        return this.shopid - 0
      }
    },
    methods: {
      ...mapActions('shop', [
        'setShopID',
        'setCategory'
      ])
    }
  }
}
